<app-customer-grid #CustomerGridComponent style="max-width: 300px; width:100%; height: 100%;
overflow-y: auto;" (companyEmit)="loadCompanyDetail($event)"></app-customer-grid>
<mat-tab-group #CustomerMatTabGroup>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'label.details' | translate}}</span>
        </ng-template>
        <app-customer-detail (contractEmit)="loadContract($event)" style="width:100%" [companyDetail_]="companyDetail"
            (companyDetailEmit)="refreshGrid()" (refreshEmit)="refreshCompany()">
        </app-customer-detail>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>{{ 'label.contracts' | translate}}</span>
        </ng-template>
        <app-contract-detail [companyDetail_]="companyDetail" style="width:100%" (refreshEmit)="refreshCompany()" (backToCustomerEmit)="backToCustomer()">
        </app-contract-detail>
    </mat-tab>
</mat-tab-group>